import {makeApolloClientCall} from "../../../../Api/makeApolloApiCall";

export async function fetchStoreTotalsData(queries) {
    const [sales, fill, averages, configs] = await Promise.all([
        makeApolloClientCall(queries.sales, false),
        makeApolloClientCall(queries.fill, false),
        makeApolloClientCall(queries.averages, false),
        makeApolloClientCall(queries.configs, false)
    ]);
    return {...sales, ...fill, ...averages, ...configs};
}
